import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsToggle2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSettingsToggle2"><Path d="M1.5 12C1.5 8.96243 3.96243 6.5 7 6.5H17C20.0376 6.5 22.5 8.96243 22.5 12C22.5 15.0376 20.0376 17.5 17 17.5H7C3.96243 17.5 1.5 15.0376 1.5 12Z" stroke="currentColor"/><Path d="M11.5 12C11.5 8.96243 13.9624 6.5 17 6.5C20.0376 6.5 22.5 8.96243 22.5 12C22.5 15.0376 20.0376 17.5 17 17.5C13.9624 17.5 11.5 15.0376 11.5 12Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconSettingsToggle2;
